/**
 * verticalCardInfo.tsx
 */
import Addon from '@shared/classes/addon';
import Button from '../../../buttons/ui/cardButton';
import Container from '../../../../atoms/container/verticalCardInfoContainer';
import Event from '@shared/classes/event';
import FlavourConfig from '@shared/config/flavours';
import Plan from '@shared/classes/plan';
import Setting from '@shared/classes/setting';
import { CardButtonIcon } from '@shared/types/enums/card';
import { useMemo } from 'react';

/**
 * Props for vertical card info.
 */
interface Props {
  item: Addon | Event | Setting;
  focused: boolean;
  plan: Plan | null;
}

/**
 * Displays the vertical card info.
 */
export default function VerticalCardInfo({ focused = false, plan }: Props) {
  const { color, display, icon, text } = useMemo(() => {
    const color = plan?.colorHex;
    const display = !!plan;
    let icon;
    let text;
    if (plan) {
      icon = CardButtonIcon.PLAN;
      text = focused
        ? plan?.name
        : plan?.name.replace(FlavourConfig.appTitle, '');
    }
    return { color, display, icon, text };
  }, [focused, plan]);

  return (
    <Container>
      {display ? (
        <Button color={color} focused={focused} iconType={icon} text={text} />
      ) : null}
    </Container>
  );
}
